
const breadcrumbSchema = ({ items }) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",

  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    ...(item.url && {
      item: item.url,
    }),
  })),
});

export default breadcrumbSchema;
